import { render } from "./App.vue?vue&type=template&id=66f336c9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=66f336c9&lang=scss"

import exportComponent from "D:\\project2025\\luck-draw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__